import { Stack } from '@starryui10/layouts/Stack';
import { AreaLoader } from '@starryui10/Loading/AreaLoader';
import React from 'react';

export const OptionLoader = () => {
    return (
        <Stack height="40px" align="center" pad="small">
            <AreaLoader caption="" />
        </Stack>
    );
};
